export enum AppDialog {
  ClaimWizard,
  ClaimWaitingReward,
  ClaimSuccess,
  WalletInfo,
  NftPurchaseSuccess,
  RewardsListApproveDialog
}
